export interface EmbedCodeInput {
  checkoutUrl: string;
  overlayUrl: string;
}

// overlay.js finds `.cp-checkout` elements and `.cp-button` links by class, so these class
// names and the data-checkout attribute are the contract with the embed widget in embed/src.
export function getEmbedCode({ checkoutUrl, overlayUrl }: EmbedCodeInput) {
  return `<div class="cp-checkout" data-checkout="${checkoutUrl}" style="width: 100%;"></div>
<script type="text/javascript" src="${overlayUrl}" async></script>`;
}

export function getPopupScriptCode({ overlayUrl }: Pick<EmbedCodeInput, 'overlayUrl'>) {
  return `<script type="text/javascript" src="${overlayUrl}" async></script>`;
}

export function getPopupButtonCode({
  checkoutUrl,
  label = 'Buy now',
}: Pick<EmbedCodeInput, 'checkoutUrl'> & { label?: string }) {
  return `<a href="${checkoutUrl}" class="cp-button">${label}</a>`;
}

export function getPopupCode({ checkoutUrl, overlayUrl }: EmbedCodeInput) {
  return {
    scriptCode: getPopupScriptCode({ overlayUrl }),
    popUpCode: getPopupButtonCode({ checkoutUrl }),
  };
}
